import { Dispatch, SetStateAction, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Modal, Select, Button, Input, Confirm } from "semantic-ui-react";
/*
import {
    SetRangeFromInitial,
    SetDefaultUpwards,
    SetDefaultDownwards,
} from "../../../../../actions/ccValidationActions";
 */

import {
    parseInitialCgmFromZip,
    IInitialCgm,
    mapInitialCgmToRow,
} from "../../../../../containers/StudyPage/initialCgmHelper";
import {
    applyFilter,
    IPstRow,
    mapPstToExcelRow,
    parseExcelFromZip,
} from "../../../../../containers/StudyPage/xlsxHelper";
import { AppState } from "../../../../../store/configureStore";
import * as XLSX from "xlsx";
import JSZip from "jszip";
import { SetZipFile } from "../../../../../actions/filesActions";
import { groupBy } from "lodash";
import "./PstTableModal.css";

interface IProps {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const PstTableRow = (row: IPstRow, onChange: any) => {
    return (
        <Table.Row
            id="pst-table-row"
            className="pst-table-row"
            key={`pst-table-row-${row.raID}-${row.timestamp}-${Math.random()}`}
        >
            <Table.Cell
                selectable
                id="pst-table-cell-ra-id"
                className="content-cell"
                key={`pst-table-cell-ra-id-${row.raID}-${row.timestamp}`}
            >
                {row.raID}
            </Table.Cell>
            <Table.Cell
                selectable
                id="pst-table-cell-name-of-ra"
                className="content-cell"
                key={`pst-table-cell-name-of-ra-${row.raID}-${row.timestamp}`}
            >
                {row.nameoftheRA}
            </Table.Cell>
            <Table.Cell
                selectable
                id="pst-table-cell-node-from"
                className="content-cell"
                key={`pst-table-cell-node-from-${row.raID}-${row.timestamp}`}
            >
                {row.nodeFrom}
            </Table.Cell>
            <Table.Cell
                selectable
                id="pst-table-cell-node-to"
                className="content-cell"
                key={`pst-table-cell-node-to-${row.raID}-${row.timestamp}`}
            >
                {row.nodeTo}
            </Table.Cell>
            <Table.Cell
                selectable
                id="pst-table-cell-range-from"
                className="content-cell"
                key={`pst-table-cell-range-from-${row.raID}-${row.timestamp}`}
            >
               {row.rangeFrom} 
            </Table.Cell>
            <Table.Cell
                selectable
                id="pst-table-cell-range-to"
                className="content-cell"
                key={`pst-table-cell-range-to-${row.raID}-${row.timestamp}`}
            >
                {row.rangeTo} 
            </Table.Cell>
            <Table.Cell
                selectable
                id="pst-table-cell-initial-cgm"
                className="content-cell"
                key={`pst-table-cell-initial-cgm-${row.raID}-${row.timestamp}`}
            >
                {row.initialCGM}
            </Table.Cell>
            <Table.Cell
                selectable
                id="pst-table-cell-downwards-range"
                className="content-cell"
                key={`pst-table-cell-downwards-range-${row.raID}-${row.timestamp}`}
            >
                <Input
                    type="number"
                    key={`pst-table-cell-downwards-range-input-${row.raID}-${row.timestamp}`}
                    value={row.downwardsRange}
                    onChange={(e: any) =>
                        onChange({ downwardsRange: e.target.value }, row.raID)
                    }
                />
            </Table.Cell>
            <Table.Cell
                selectable
                id="pst-table-cell-upwards-range"
                className="content-cell"
                key={`pst-table-cell-upwards-range-${row.raID}-${row.timestamp}`}
            >
                <Input
                    type="number"
                    key={`pst-table-cell-upwards-range-input-${row.raID}-${row.timestamp}`}
                    value={row.upwardsRange}
                    onChange={(e: any) =>
                        onChange({ upwardsRange: e.target.value }, row.raID)
                    }
                />
            </Table.Cell>
        </Table.Row>
    );
};

export const PstTableModal = ({ isOpen, setIsOpen }: IProps) => {
    const zipFile = useSelector((state: AppState) => state.files.zipFile);
    const ccValidation = useSelector((state: AppState) => state.ccValidation);
    const validationProcess = useSelector((state: AppState) => state.validationProcess.process);
    const dispatch = useDispatch();

    const [parsedRows, setParsedRows] = useState<IPstRow[]>();
    const [rows, setRows] = useState<IPstRow[]>();
    const [initialCgms, setInitialCgms] = useState<IInitialCgm[]>();
    const [selectedTimestamp, setSelectedTimestamp] = useState<number>(-1);
    const [saveDisabled, setSaveDisabled] = useState<boolean>(false);
    const [saveSuccessful, setSaveSuccessful] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isZipLoading, setIsZipLoading] = useState<boolean>(false);
    const [saveFailed, setSaveFailed] = useState<boolean>(false);
    const [unsavedChanges, setUnsavedChanges] = useState<boolean>(false);
    const [isConfirmOpen, setIsConfirmOpen] = useState<boolean>(false);
    const activeTimestampsOptions = useSelector((state: AppState) => state.timestamps.timestamps);
    const availableTimestampsOrScenarios = useSelector(
        (state: AppState) => state.validationProcess.availableTimestampsOrScenarios
    );
    const [defaultUpwards, SetDefaultUpwards] = useState<number>(0);
    const [defaultDownwards, SetDefaultDownwards] = useState<number>(0);
    const [backupParsedRows, setBackupParsedRows] = useState<IPstRow[]>();
    const [backupDefaultUpwards, setBackupDefaultUpwards] = useState<number>(0);
    const [backupDefaultDownwards, setBackupDefaultDownwards] = useState<number>(0);
    const backupCreatedRef = useRef<boolean>(false);

    const onChange = (diff: Partial<IPstRow>, id: string) => {
        setParsedRows(
            parsedRows?.map(row => {
                if (row.raID === id && row.timestamp === selectedTimestamp) {
                    return {
                        ...row,
                        ...diff,
                        upwardsRangeManual: row.upwardsRangeManual || Boolean(diff.upwardsRange),
                        downwardsRangeManual:
                            row.downwardsRangeManual || Boolean(diff.downwardsRange),
                    };
                } else {
                    return row;
                }
            })
        );
        setUnsavedChanges(true);
    };

    const onApply = (applyAll: boolean) => {
        if (!parsedRows || !rows) {
            return;
        }

        const newParsedRows = parsedRows.map(row => {
            const isExcluded = !applyAll && row.timestamp !== selectedTimestamp;

            if (isExcluded) {
                return { ...row };
            }

            return {
                ...row,
                downwardsRange: row.downwardsRangeManual
                    ? row.downwardsRange
                    /*
                    : ccValidation.defaultDownwards,
                    */
                    : defaultDownwards,
                upwardsRange: row.upwardsRangeManual
                    ? row.upwardsRange
                    /*
                    : ccValidation.defaultUpwards,
                    */
                    : defaultUpwards
            };
        });

        setParsedRows(newParsedRows);
        setUnsavedChanges(true);
    };

    const rowsAreSame = (row: IPstRow, comparisonRow: IPstRow) => {
        return (
            row.downwardsRange?.toString() === comparisonRow.downwardsRange?.toString() &&
            row.upwardsRange?.toString() === comparisonRow.upwardsRange?.toString() &&
            row.rangeFrom.toString() === comparisonRow.rangeFrom.toString() &&
            row.rangeTo.toString() === comparisonRow.rangeTo.toString()
        );
    };

    const createAggregatedPst = (referenceValue: IPstRow, from: number, to: number) => {
        const fromFullHour = `${from.toString().padStart(2, "0")}:00`;
        const toFullHour = `${(to + 1).toString().padStart(2, "0")}:00`;

        const aggregatedRow: IPstRow = { ...referenceValue };
        aggregatedRow.timeFrom = fromFullHour;
        aggregatedRow.timeTo = toFullHour;
        return aggregatedRow;
    };

    const aggregatePstRows = (rows: IPstRow[]) => {
        let aggregatedData: IPstRow[] = [];
        const groupedData = groupBy(rows, rows => rows.raID);
        for (const key in groupedData) {
            const group: IPstRow[] = groupedData[key];
            let comparisonValue: IPstRow = group[0];
            let timeFrom = 0;
            let timeTo = 0;
            let lastUsedFrom = -1;
            let lastUsedTo = -1;
            for (let index = 0; index < group.length; index++) {
                const row = group[index];
                if (rowsAreSame(row, comparisonValue)) {
                    timeTo = row.timestamp;
                } else {
                    const aggregatedRow = createAggregatedPst(comparisonValue, timeFrom, timeTo);
                    aggregatedData.push(aggregatedRow);

                    lastUsedFrom = timeFrom;
                    lastUsedTo = timeTo;
                    timeFrom = row.timestamp;
                    timeTo = row.timestamp;
                    comparisonValue = row;
                }
            }
            // Push leftover
            if (lastUsedFrom !== timeFrom && lastUsedTo !== timeTo) {
                const aggregatedRow = createAggregatedPst(comparisonValue, timeFrom, timeTo);
                aggregatedData.push(aggregatedRow);
            }
        }
        return aggregatedData;
    };

    const onSave = async () => {
        setSaveDisabled(true);
        if (!parsedRows || !zipFile) {
            setSaveDisabled(false);
            setSaveFailed(true);
            setTimeout(() => {
                setSaveFailed(false);
            }, 2000);
            return;
        }

        const filteredRows = applyFilter(parsedRows, [...Array(24).keys()]);
        let aggregated = aggregatePstRows(filteredRows);

        const zip = await JSZip.loadAsync(zipFile);
        let filename: string | undefined;
        filename = Object.keys(zip.files).find(f => f.endsWith(".xlsx") && f.includes("MODIFIED"));
        if (!filename) filename = Object.keys(zip.files).find(f => f.endsWith(".xlsx"));
        if (filename === undefined || (filename && zip.file(filename) === null)) {
            setSaveDisabled(false);
            setSaveFailed(true);
            setTimeout(() => {
                setSaveFailed(false);
            }, 2000);
            return;
        }

        const blob = await zip.file(filename)!.async("blob");
        const workbook = XLSX.read(await blob.arrayBuffer());
        let sheet = workbook.Sheets["PST"];
        XLSX.utils.sheet_add_json(
            sheet,
            aggregated.map(x => mapPstToExcelRow(x))
        );
        workbook.Sheets["PST"] = sheet;

        const modifiedXlsx = XLSX.writeXLSX(workbook, { type: "binary" });
        const modifiedFilename = filename.includes("MODIFIED")
            ? filename
            : `${filename.replace(/\.[^/.]+$/, "")}_MODIFIED.xlsx`;
        zip.file(modifiedFilename, modifiedXlsx, { binary: true });

        dispatch(
            SetZipFile(
                new File([(await zip.generateAsync({ type: "blob" })) as BlobPart], zipFile.name)
            )
        );
        setBackupParsedRows(parsedRows.map(row => ({ ...row })));
        setBackupDefaultUpwards(defaultUpwards);
        setBackupDefaultDownwards(defaultDownwards);
        setSaveDisabled(false);
        setSaveSuccessful(true);
        setTimeout(() => {
            setSaveSuccessful(false);
        }, 3000);
        setUnsavedChanges(false);
    };

    useEffect(() => {
        const fetchRows = async () => {
            if (zipFile) {
                let data = await parseExcelFromZip(zipFile);
                const initialCgmData = await parseInitialCgmFromZip(
                    zipFile,
                    data,
                    availableTimestampsOrScenarios
                );
                setInitialCgms(initialCgmData);
                if (initialCgmData)
                    data = data?.filter(x => !(x.nodeFrom.endsWith("*") || x.nodeTo.endsWith("*")));

                setParsedRows(data);
            }

            setIsZipLoading(false);
        };

        setIsZipLoading(true);
        fetchRows();
        setUnsavedChanges(false);
    }, [zipFile, availableTimestampsOrScenarios]);

    // Create backup of original data when modal opens and data is available
    useEffect(() => {
        if (isOpen && parsedRows && parsedRows.length > 0 && !backupCreatedRef.current) {
            setBackupParsedRows(parsedRows.map(row => ({ ...row })));
            setBackupDefaultUpwards(defaultUpwards);
            setBackupDefaultDownwards(defaultDownwards);
            setUnsavedChanges(false);
            backupCreatedRef.current = true;
        }
    }, [isOpen, parsedRows, defaultUpwards, defaultDownwards]);

    useEffect(() => {
        if (!isOpen) {
            backupCreatedRef.current = false;
        }
    }, [isOpen]);

    useEffect(() => {
        setSelectedTimestamp(-1);
    }, [validationProcess, isOpen]);

    useEffect(() => {
        if (parsedRows) {
            let filteredRows = applyFilter(
                parsedRows.map(x => ({ ...x })),
                [selectedTimestamp]
            );
            if (initialCgms)
                filteredRows = mapInitialCgmToRow(
                    filteredRows.map(x => ({ ...x })),
                    initialCgms,
                    selectedTimestamp
                );
            setRows(filteredRows);
            setIsLoading(false);
        }
    }, [parsedRows, selectedTimestamp, initialCgms]);

    const restoreFromBackup = () => {
        if (backupParsedRows) {
            setParsedRows(backupParsedRows.map(row => ({ ...row })));
            SetDefaultUpwards(backupDefaultUpwards);
            SetDefaultDownwards(backupDefaultDownwards);
            setUnsavedChanges(false);
        }
    };

    const handleClose = () => {
        if (unsavedChanges && parsedRows) {
            setIsConfirmOpen(true);
        } else {
            setIsOpen(false);
            setSelectedTimestamp(-1);
        }
    };

    return (
        <>
            <Confirm
                className="pst-table-confirm-exit"
                dimmer
                centered
                open={isConfirmOpen}
                content="Changes are only applied after saving them, do you still wish to close the table?"
                onCancel={() => {
                    setIsConfirmOpen(false);
                }}
                onConfirm={() => {
                    restoreFromBackup();
                    setIsConfirmOpen(false);
                    setIsOpen(false);
                    setSelectedTimestamp(-1);
                }}
            />
            <Modal
                open={isOpen}
                id="pst-table-modal"
                dimmer="blurring"
                className="pst-table-modal-container transition-container"
            >
                <Modal.Header className="pst-table-header">
                    <span>PST Ranges</span>
                    <Button
                        id="pst-table-close-button"
                        className="pst-table-button"
                        color="red"
                        onClick={handleClose}
                    >
                        <span>Close table</span>
                    </Button>
                    <Button
                        id="pst-table-save-button"
                        className="pst-table-button"
                        color="green"
                        onClick={onSave}
                        disabled={!(zipFile && parsedRows && rows) || saveDisabled}
                    >
                        <span>Save</span>
                    </Button>
                    {saveSuccessful && (
                        <Button
                            id="pst-table-save-message-button"
                            className="pst-table-button"
                            color="green"
                            label="Changes saved successfully!"
                            loading={isLoading || isZipLoading}
                        />
                    )}
                    {isZipLoading && (
                        <Button
                            id="pst-table-is-loading-button"
                            className="pst-table-button"
                            color="grey"
                            label="Loading data from zip"
                        />
                    )}
                    {saveFailed && (
                        <Button
                            id="pst-table-save-failed-button"
                            className="pst-table-button"
                            color="red"
                            label="Failed to save changes!"
                        />
                    )}
                </Modal.Header>
                <div>
                    {selectedTimestamp === -1 ? <p>Please select a timestamp</p> : <p>Timestamp</p>}
                    <Select
                        id="pst-table-timestamp"
                        selectOnBlur={false}
                        placeholder="Select a timestamp"
                        value={selectedTimestamp}
                        options={activeTimestampsOptions}
                        onChange={(_e, data: any) => setSelectedTimestamp(data.value)}
                    />
                </div>
                <div id="pst-table-range-options" className="pst-table-range-options">
                    {/*
                    <div id="pst-table-options-rangeFromInitial" className="cc-validation-input">
                        <p>Range from initial</p>
                        <Radio
                            toggle
                            name="rangeFromInitial"
                            checked={ccValidation.rangeFromInitial}
                            onChange={() =>
                                dispatch(SetRangeFromInitial(!ccValidation.rangeFromInitial))
                            }
                        />
                    </div>
                    */}
                    <div id="pst-table-options-defaultDownwards" className="cc-validation-input">
                        {/*
                        <p>Default downwards</p>
                        */}
                        <p>Per Timestamp downwards</p>
                        <Input
                            id="input-CCValidation-region-options-defaultDownwards"
                            name="defaultDownwards"
                            pattern="^-?[0-9]\d*\.?\d*$"
                            className="text-input"
                            type="number"
                            /*
                            value={ccValidation.defaultDownwards}
                            */
                            value={defaultDownwards}
                            onChange={(e: any) => {
                                if (e.target.validity.valid || e.target.value === "") {
                                    /*
                                    dispatch(SetDefaultDownwards(e.target.value));
                                    */
                                    SetDefaultDownwards(e.target.value);
                                    setUnsavedChanges(true);
                                }
                            }}
                            disabled={!ccValidation.rangeFromInitial}
                        />
                    </div>
                    <div id="pst-table-options-defaultUpwards" className="cc-validation-input">
                         {/*
                        <p>Default upwards</p>
                        */}
                        <p>Per Timestamp upwards</p>
                        <Input
                            id="input-CCValidation-region-options-defaultUpwards"
                            name="defaultUpwards"
                            pattern="^-?[0-9]\d*\.?\d*$"
                            className="text-input"
                            type="number"
                            /*
                            value={ccValidation.defaultUpwards}
                            */
                            value={defaultUpwards}
                            onChange={(e: any) => {
                                if (e.target.validity.valid || e.target.value === "") {
                                    /*
                                    dispatch(SetDefaultUpwards(e.target.value));
                                    */
                                    SetDefaultUpwards(e.target.value);
                                    setUnsavedChanges(true);
                                }
                            }}
                            disabled={!ccValidation.rangeFromInitial}
                        />
                    </div>
                    <div className="cc-validation-input">
                        <p>{String.fromCharCode(160)}</p>
                        <Button onClick={() => onApply(false)} disabled={isZipLoading}>
                            Apply to selected timestamp
                        </Button>
                        <Button onClick={() => onApply(true)} disabled={isZipLoading}>
                            Apply to all timestamps
                        </Button>
                    </div>
                </div>
                <Table id="pst-table" celled striped>
                    <Table.Header id="pst-table-header">
                        <Table.Row id="pst-table-header-row">
                            <Table.HeaderCell id="pst-table-header-ra-id">
                                RA ID
                            </Table.HeaderCell>
                            <Table.HeaderCell id="pst-table-header-pst">PST</Table.HeaderCell>
                            <Table.HeaderCell id="pst-table-header-nodeFrom">
                                Node from
                            </Table.HeaderCell><Table.HeaderCell id="pst-table-header-nodeTo">
                                Node To
                            </Table.HeaderCell>
                            <Table.HeaderCell id="pst-table-header-rangeFrom">
                                Range From
                            </Table.HeaderCell>
                            <Table.HeaderCell id="pst-table-header-rangeTo">
                                Range To
                            </Table.HeaderCell>
                            <Table.HeaderCell id="pst-table-header-initial-cgm">
                                initial CGM
                            </Table.HeaderCell>
                            <Table.HeaderCell id="pst-table-header-downward">
                                Downwards
                            </Table.HeaderCell>
                            <Table.HeaderCell id="pst-table-header-upwards">
                                Upwards
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body id="pst-table-body">
                        {rows ? (
                            rows.map(row => PstTableRow(row, onChange))
                        ) : (
                            <Table.Row>
                                <Table.Cell>Please input the zip file</Table.Cell>
                            </Table.Row>
                        )}
                    </Table.Body>
                </Table>
            </Modal>
        </>
    );
};
